import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Asset } from './asset.dto';
import { ChangeTyped, SearchResult, WW_ASSETS_COLLECTION } from '@damofire/data-commons';
import { ObservableAssetService } from './asset-observable.service';
import { FirebaseObservableServiceFactory } from '@damofire/data-angular-commons';
import { TypedDesQuery } from '../des.dto';
import { FirebaseWatsonObservableService } from '../firebase-watson-observable.service';
import { FirebaseObservableNoteService } from '../note/firebase-note-observable.service';

@Injectable()
export class FirebaseObservableAssetService extends ObservableAssetService {
  private readonly firebaseWatsonObservableService: FirebaseWatsonObservableService<Asset>;

  constructor(
    private readonly firebaseObservableServiceFactory: FirebaseObservableServiceFactory,
    private readonly firebaseObservableNoteService: FirebaseObservableNoteService,
  ) {
    super(firebaseObservableNoteService);
    this.firebaseWatsonObservableService = new FirebaseWatsonObservableService(firebaseObservableServiceFactory, WW_ASSETS_COLLECTION);
  }

  observeById(divisionId: string, id: string): Observable<ChangeTyped<Asset>> {
    return this.firebaseWatsonObservableService.observeDoc(id);
  }

  observeBySection(divisionId: string, section: string): Observable<ChangeTyped<Asset>[]> {
    return this.firebaseWatsonObservableService.observeByWarehousePiped(
      divisionId,
      map((fromFirestore) => {
        return fromFirestore.filter((doc) => doc.section === section);
      }),
    );
  }

  observeBySystem(divisionId: string, system: number): Observable<ChangeTyped<Asset>[]> {
    return this.firebaseWatsonObservableService.observeByWarehousePiped(
      divisionId,
      map((fromFirestore) => {
        return fromFirestore.filter((doc) => doc.system === system);
      }),
    );
  }

  noteableSearch(id: string, sQuery: TypedDesQuery): Observable<SearchResult<Asset>> {
    return this.firebaseWatsonObservableService.search(id, sQuery, this.SEARCH_FIELDS);
  }
}
